// Stage 1's card. Deliberately thin: lnat_scoring_service._reasoning_trace_summary
// sends only aggregate counts (nodes engaged, nodes total, graph coverage), not
// the per-node quotes and weights -- those are grading internals the examiner
// report explains in plain English, not something to show ahead of it.

import React from 'react';
import { Prose } from './TaraFeedbackBlocks';

export default function LnatReasoningTraceFeedback({ feedback }) {
  if (!feedback) return null;
  const engaged = Number.isFinite(feedback.nodes_engaged) ? feedback.nodes_engaged : null;
  const total = Number.isFinite(feedback.nodes_total) ? feedback.nodes_total : null;
  const coverage = Number.isFinite(feedback.graph_coverage_pct)
    ? feedback.graph_coverage_pct : null;

  return (
    <div className="lnat-fb-trace">
      {engaged !== null && total !== null ? (
        <p className="tara-fb-prose">
          {`Your essay engaged with ${engaged} of ${total} reasoning nodes in this question's `
            + "argument structure."}
        </p>
      ) : null}
      {coverage !== null ? (
        <p className="tara-fb-prose">
          {`Reasoning graph coverage: ${coverage}%.`}
        </p>
      ) : null}
      <Prose className="tara-fb-soft">
        Run the examiner report to see what this means and how to improve it.
      </Prose>
    </div>
  );
}
